import Homesection1 from './pages/Homesection1.jsx';
import Homesection2 from './pages/Homesection2.jsx';
import Homesection3 from './pages/Homesection3.jsx';
import Homesection4 from './pages/Homesection4.jsx';
import Homesection5 from './pages/Homesection5.jsx';
import Homesection6 from './pages/Homesection6.jsx';
import Fotter from './pages/Fotter.jsx';

function App() {
  return (
    <div className="App">
      <Homesection1/>
      <Homesection2/>
      <Homesection3/>
      <Homesection4/>
      <Homesection5/>
      <Homesection6/>
      <Fotter/>
    
    </div>
  );
}

export default App;
